module.exports = __webpack_public_path__ + "static/media/blom-pysanky-thumb-32.6569bbb0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/blom-pysanky/blom-pysanky-thumb-32.jpg
// module id = 3988
// module chunks = 13